import React from "react";
import { Chip } from "@material-ui/core";
import { STATUS_BY_LABEL, STATUS_LABELS } from "../constants";
import useAssistedAffiliationStyles from "../styles";
import type { AssistedAffiliationStatus } from "../types";

type StatusChipProps = {
  status?: AssistedAffiliationStatus;
  label?: string;
  size?: "small" | "medium";
};

const StatusChip = ({ status, label, size = "small" }: StatusChipProps) => {
  const classes = useAssistedAffiliationStyles();
  const statusCode = status || STATUS_BY_LABEL[label || ""];
  const chipLabel = label || (status ? STATUS_LABELS[status] : "");
  const chipClassByStatus: Partial<Record<AssistedAffiliationStatus, string>> = {
    DRAFT: classes.chipDraft,
    IN_PROGRESS: classes.chipInProgress,
    PENDING_INFORMATION: classes.chipDraft,
    COMMERCE_CREATED: classes.chipSuccess,
    REQUEST_CANCELLED: classes.chipError,
    CREATION_ERROR: classes.chipError,
  };

  return (
    <Chip
      label={chipLabel}
      size={size}
      className={`${classes.statusChip} ${statusCode ? chipClassByStatus[statusCode] || "" : ""}`}
    />
  );
};

export default StatusChip;
